<template>

  <div class="plugins-container">

    <v-list
      v-if    = "plugins.schemas.length > 0"
      dense
      class   = "selector"
    >
      <v-list-item-group
        mandatory
        class     = "group"
        :value    = "plugins.selection"
      >
        <v-list-item
          v-for   = "(schema, index) of plugins.schemas"
          :key    = "index"
          @click  = "onPluginSelected(index);"
        >
          {{ schema.name }}
        </v-list-item>
      </v-list-item-group>

    </v-list>

    <div
      class   = "form-container"
      v-if    = "selectedSchema"
    >

      <div class="form-scroll-wrapper">
        <v-form
          class   = "form"
          v-model = "selectedSchema.valid"
        >
          <v-jsf
            v-model       = "selectedSchema.model"
            :schema       = "selectedSchema.schema"
            :options      = "selectedSchema.options"
            :timecode     = "timecode"
            @change-child = "onSchemaFormChildChange"
          />
          <template slot="imageProp">
          </template>
        </v-form>

        <div class="button-bar">
          <v-btn
            v-if = "selectedSchema.settings"
            icon
            dark
            @click  = "onShowPluginSettings"
          >
            <v-icon>mdi-cog</v-icon>
          </v-btn>

          <v-btn
            color   = "primary"
            @click  = "onExecutePlugin"
          >
            Submit
          </v-btn>

        </div>
      </div>

    </div>

    <PluginSettingsDialog ref="plugin_settings_dialog"></PluginSettingsDialog>
    <ConfirmationDialog ref="confirmation_dialog"></ConfirmationDialog>
  </div>

</template>

<script lang="js">

// #region Imports

/* vuex */
import { mapState } from 'vuex';

/* Telestream */
import { EXECUTE_PLUGIN, UPDATE_PLUGIN_MODEL, UPDATE_PLUGIN_SETTINGS } from '@/utils/action-types';
import { SET_PLUGIN_SELECTION } from '@/utils/mutation-types';
import PluginSettingsDialog from './components/dialogs/PluginSettingsDialog';
import { ConnectionService } from '../../services/connection.service';
import ConfirmationDialog from './components/dialogs/ConfirmationDialog';

// #endregion Imports

export default {

  // #region Properties

  name:       'PluginsPane',
  components: {
    PluginSettingsDialog,
    ConfirmationDialog
  },
  computed: {
    ...mapState([
      'plugins',
      'video'
    ]),
    selectedSchema() {
      return this.plugins.schemas[this.plugins.selection];
    },
    timecode() {
      return `${this.video.currentTimecode} [frame ${this.video.currentFrame}]`;
    }
  },

  // #endregion Properties

  // #region Events

  methods: {

    onPluginSelected(index) {
      this.$store.commit(SET_PLUGIN_SELECTION, index);
    },

    onSchemaFormChildChange() {
      this.$store.dispatch(UPDATE_PLUGIN_MODEL, this.selectedSchema);
    },

    async onExecutePlugin() {
      console.log(this.selectedSchema.name);
      if(this.selectedSchema.name == 'Unload') {
        const managerConnection = ConnectionService.getConnection('/manager');
        await managerConnection.start();
        if (await managerConnection.invoke('IsFileInUseByOthers', this.$store.state.videoPath)) {
          if (await this.$refs.confirmation_dialog.confirm(
            'Unload video?',
            'Another user is using this file. Are you sure you want to unload this video?',
            'Unload Video',
            'error',
            'Keep Video',
            'primary'
          )) {
            this.$store.dispatch(EXECUTE_PLUGIN, this.selectedSchema);
          }
        }
        else {
          this.$store.dispatch(EXECUTE_PLUGIN, this.selectedSchema);
        }
        managerConnection.stop();
      }
      else {
        this.$store.dispatch(EXECUTE_PLUGIN, this.selectedSchema);
      }
    },

    async onGetUpdatedSchema(settingsModel) {
      const newSchemaString = await this.plugins.connection.invoke(
        'GetSchema',
        this.selectedSchema.name,
        JSON.stringify(settingsModel)
      );

      if (newSchemaString == "") // could not get schema from the backend storage
        return;

      return JSON.parse(newSchemaString);
    },

    async onShowPluginSettings() {
      if (this.selectedSchema) {
        const settingsModelString = await this.plugins.connection.invoke('GetSettings', this.selectedSchema.name);

        if (settingsModelString == "") // could not get settings model from the backend storage
          return;

        const schemaString = await this.plugins.connection.invoke('GetSchema', this.selectedSchema.name, settingsModelString);

        if (schemaString == "") // could not get schema from the backend storage
          return;

        const schema = JSON.parse(schemaString);

        const newSettingsModel = await this.$refs.plugin_settings_dialog.configure(
          this.selectedSchema.name,
          JSON.parse(settingsModelString),
          schema.settings.schema,
          schema.settings.options,
          async () => JSON.parse(await this.plugins.connection.invoke('RestoreDefaultSettings', 'Plugin', this.selectedSchema.name)),
          schema.hasDynamicSettings ? this.onGetUpdatedSchema : undefined
        );

        if (newSettingsModel) {
          this.$store.dispatch(UPDATE_PLUGIN_SETTINGS, { pluginName: this.selectedSchema.name, settingsModel: newSettingsModel });
        }
      }
    }
  }

  // #endregion Events

};

</script>

<style lang="scss" scoped>

.plugins-container {
  display:        flex;
  flex-direction: row;
  height:         100%;

  .selector {
    padding:      0px;
    min-width:    240px;
    overflow-y:   scroll;

    .group {
      height:       0px;
    }
  }

  .form-container {
    flex:           1;
    position:       relative;

    .form-scroll-wrapper {
      position:       absolute;
      top:            0;
      right:          0;
      bottom:         0;
      left:           0;

      display:        flex;
      flex-direction: column;

      .form {
        padding:        24px;
        flex:           1;
        overflow:       auto;
      }

      .button-bar {
        background:     rgba(0, 0, 0, 0.3);
        padding:        8px;
        text-align:     right;
      }
    }
  }
}

</style>